jQuery(function ($) {
	$(".current-product_cat-ancestor").each(function () {

		let item = $(this)

		item.closest(".parent-item-li").addClass("current-menu-ancestor current-menu-parent")

		if (item.closest(".parent-item-li").hasClass('servicii-page')) {
			const params = new URL(window.location.href).searchParams;
			const servicii = params.get("servicii");
			$(".parent-item-li").each(function () {
				if (!$(this).hasClass('servicii-page') && servicii) {
					$(this).removeClass('current-menu-ancestor current-menu-parent')
				}
				else if ($(this).hasClass('servicii-page') && !servicii) {
					$(this).removeClass('current-menu-ancestor current-menu-parent')
				}
			})
		}

		item
			.find("a")
			.each(function () {
				let url = $(this).attr("href")

				if (url === window.location.href) {
					$(this).addClass("current-menu-item")
				}
			})
	})

	setTimeout(function(){
		$('.wc-block-checkout__use-address-for-billing label').trigger('click')
	},1000)

	$(document).on('click', '.wc-block-components-address-card__edit', function(){

		let company = $('#shipping-company')

		if( $(this).attr('aria-controls') == 'billing' ){
			company = $('#billing-company')
		}
		console.log(company)
		let company_fields = $('.wc-block-components-address-form__thwcfe-block-company_banca, .wc-block-components-address-form__thwcfe-block-company_cont, .wc-block-components-address-form__thwcfe-block-company_nr_reg_com, .wc-block-components-address-form__thwcfe-block-company_cui')

		if( !company.closest('.wc-block-components-text-input').hasClass('has-value') ){
			if( company.val() ){
				company.closest('.wc-block-components-text-input').addClass('has-value')
				company_fields.slideDown(200)
			}
		}
		else{
			if( ! company.val() ){
				company.closest('.wc-block-components-text-input').removeClass('has-value')
				company_fields.slideUp(200)
			}
		}
	})

	$(document).on('input', '#shipping-company, #billing-company', function(){

		let company_fields = $('.wc-block-components-address-form__thwcfe-block-company_banca, .wc-block-components-address-form__thwcfe-block-company_cont, .wc-block-components-address-form__thwcfe-block-company_nr_reg_com, .wc-block-components-address-form__thwcfe-block-company_cui')

		if( !$(this).closest('.wc-block-components-text-input').hasClass('has-value') ){
			if( $(this).val() ){
				$(this).closest('.wc-block-components-text-input').addClass('has-value')
				company_fields.slideDown(200)
			}
		}
		else{
			if( ! $(this).val() ){
				$(this).closest('.wc-block-components-text-input').removeClass('has-value')
				company_fields.slideUp(200)
			}
		}
	})

	if ($(window).width() < 992) {
		$(".menu-item-has-children > .menu-item-link").on("click", function () {
			let btn = $(this)
			let sub_menu = btn.closest(".parent-item-li").find(".sub-menu")

			if (!sub_menu.hasClass("active")) {
				btn.closest(".menu-main")
					.find(".sub-menu")
					.slideUp(400, function () {
						$(this).removeClass("active")
					})
				sub_menu.slideDown(400, function () {
					$(this).addClass("active")
				})
			} else {
				sub_menu.slideUp(400).removeClass("active")
				sub_menu.find(".menu-item-link").removeClass("active")
				sub_menu.find(".sub-menu-container").slideUp(100)
			}
		})
	} else {
		$(".menu-item-has-children")
			.on("mouseenter", function () {
				let sub_menu = $(this).find(".sub-menu")

				sub_menu.fadeIn(200).addClass("active")

				let current_page = sub_menu.find(".current-product_cat-ancestor")
				if (current_page.length) {
					current_page.find(".menu-item-link").addClass("active")
					current_page.find(".sub-menu-container").fadeIn(200)
				} else {
					sub_menu.find(".parent-item-child").eq(0).find(".menu-item-link").addClass("active")
					sub_menu.find(".parent-item-child").eq(0).find(".sub-menu-container").fadeIn(200)
				}
			})
			.on("mouseleave", function () {
				let sub_menu = $(this).find(".sub-menu")

				sub_menu.fadeOut(100).removeClass("active")

				sub_menu.find(".menu-item-link").removeClass("active")
				sub_menu.find(".sub-menu-container").fadeOut(100)
			})
	}

	$(".parent-item-child .menu-item-link").on("click", function () {
		let btn = $(this)
		let parent = $(this).closest(".parent-item-child")

		if ($(window).width() < 992) {
			if (!btn.hasClass("active")) {
				parent
					.closest(".sub-menu")
					.find(".sub-menu-container")
					.slideUp(400, function () {
						parent.closest(".sub-menu").find(".menu-item-link").removeClass("active")
					})

				parent.find(".sub-menu-container").slideToggle(400, function () {
					btn.addClass("active")
				})
			} else {
				parent.find(".sub-menu-container").slideUp(400, function () {
					parent.closest(".sub-menu").find(".menu-item-link").removeClass("active")
				})
			}
		} else {
			if (!btn.hasClass("active")) {
				parent.closest(".sub-menu").find(".menu-item-link").removeClass("active")
				btn.addClass("active")
				parent.closest(".sub-menu").find(".sub-menu-container").fadeOut(100)
				parent.find(".sub-menu-container").fadeIn(200)
			}
		}
	})

	$(".open-menu-btn").on("click", function () {
		$(this).toggleClass("active")
		$(".menu-main").toggleClass("active")
		$("body").toggleClass("is-open-menu")
	})

	$(".ask-offer").on("click", function () {
		let modal = $('.ask-offer-modal');

		modal.fadeIn(200).find('.modal-meta h4 span').text($(this).attr('data-title'));
		modal.find('#product_id').val($(this).attr('data-product')).trigger('change');
		modal.find('#product_url').val($(this).attr('data-url')).trigger('change');
		modal.find('#product_title').val($(this).attr('data-title')).trigger('change');
	})

	$(".ask-offer-modal .close-modal").on("click", function () {
		$(this).closest('.ask-offer-modal').fadeOut(200);
	})

	$('.open-search').on('click', function () {
		$('.hero-search').slideToggle(300);
	})
})
